<template>
  <div>
    <HeaderComponent :headerTitle="headerText" />
    <loading v-model:active="fullPageLoading"
        :can-cancel="true"
        :color="primaryCode"
        :is-full-page="mainFullPage"/>
    <v-container fluid grid-list-lg pt-0>
      <div class="ifame_container">
        <iframe :src="decodeURL" width="100%" class="ifame-dashboard"   @load="fullPageLoading = false"></iframe>
      </div>
    </v-container>
  </div>
</template>
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent";
import Loading from 'vue-loading-overlay';
export default {
  data() {
    return {
      headerText: "Return Generation",
      iframeUrl:'',
      localUrl: '',
      decodeURL:'',
      alert: false,
      alert_type: 'info',
      alert_message: '',
      fullPageLoading : false,
      primaryCode : '#1976d2',
      mainFullPage : true
    };
  },
  components: {
    HeaderComponent, Loading
  },
  mounted() {
    this.fetchIframeUrl();
  },
  computed: {
    displayUrl() {
      return this.iframeUrl || this.localUrl;
    },
  },
  methods: {
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    fetchIframeUrl() {
       this.fullPageLoading = true;
      this.$httpSecured
        .get("/api/v2/dashboard/dashboard_embed_url")
        .then((response) => {
          if (response.data) {
            this.iframeUrl = response.data.embed_url;
            this.decodeURL = decodeURI(this.iframeUrl);
            // this.loading = true;
             this.fullPageLoading = true;
          } else {
            this.showAlert("error", "No Data Found");
            // this.loading = false;
             this.fullPageLoading = false;
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          // this.loading = false;
           this.fullPageLoading = false;
        });
    },
  },
};
</script>
<style>
.ifame_container {
  width: 99% !important;
}

.ifame-dashboard {
  height: 85vh !important;
  border: none;
  border-radius: 15px;
  --webkit-border-radius: 15px;
}
</style>
